'use strict';Object.defineProperty(exports,'__esModule',{value:!0});var _CONSTANTS=require('./constants/CONSTANTS');exports.default=function(){var layout=0<arguments.length&&arguments[0]!==void 0?arguments[0]:_CONSTANTS.LAYOUT_TYPES.DEFAULT,theme=arguments[1],values=arguments[2];if(values.hasOwnProperty(layout)){var settings=values[layout];return settings.hasOwnProperty('common')?settings.common:'light'===theme?settings.light?settings.light:'':settings.dark?settings.dark:''}return''};


//////////////////
// WEBPACK FOOTER
// ./node_modules/form-components/lib/__utils/format.js
// module id = 29
// module chunks = 0